import { Trans, useLingui } from '@lingui/react/macro';
import { ArrowRight } from '@remarkable/ark-icons';
import { Tag, Typography } from '@remarkable/ark-web';
import { LinkClicked } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import convertToNotebookWebp from 'src/assets/img/rm-designed-for-reading.webp';
import { NewsCard } from 'src/components';
import { Button } from 'src/components/Button';

interface ConvertToNotebookCardProps {
  hasSubscription: boolean;
}

export const BrowserExtensionCard = ({
  hasSubscription,
}: ConvertToNotebookCardProps) => {
  const { t } = useLingui();
  return (
    <NewsCard
      imageSources={[{ type: 'webp', url: convertToNotebookWebp }]}
      mediaAlt={t`Illustration showing the browser extension converting a web page into a reMarkable notebook`}
      mediaLink="/device/browser"
      headline="Extension"
      className="lg:flex-row-reverse"
      mediaOnClick={() => {
        tracker.trackEvent(
          new LinkClicked({
            component_location:
              ComponentLocations.FRONT_PAGE.CONVERT_TO_NOTEBOOK_CARD_IMAGE,
            text: t`Get extension`,
            link_source: '/device/browser',
          })
        );
      }}
    >
      <div className="flex flex-col gap-32">
        <div className="flex flex-col gap-16">
          <span className="flex flex-col gap-4 lm:inline-flex lm:flex-row lm:flex-wrap lm:items-center lm:gap-16">
            <Typography
              variant="responsive-heading-md"
              as="span"
              className="min-w-0"
            >
              <Trans>Import designed for focused reading</Trans>
            </Typography>
            {hasSubscription ? (
              <Tag variant="success-light" className="whitespace-nowrap">
                <Trans>New</Trans>
              </Tag>
            ) : (
              <Tag variant="info-light" className="whitespace-nowrap">
                <Trans>Connect Feature</Trans>
              </Tag>
            )}
          </span>

          <Typography
            variant="body-md"
            className="m-0 text-left"
            textWrap="pretty"
          >
            <Trans>
              Easily send articles to your paper tablet as notebooks, with Read
              on reMarkable. Ads and pop-ups are cleared, so you can read with
              focus and develop ideas with the power of the pen.
            </Trans>
          </Typography>
        </div>

        <Button
          as="a"
          variant="secondary"
          to="/device/browser"
          analytics={{
            text: t`Get extension`,
            location: ComponentLocations.FRONT_PAGE.CONVERT_TO_NOTEBOOK_CARD,
            action: 'go to read-on-remarkable page',
          }}
        >
          <span>
            <Trans>Get extension</Trans>
          </span>
          <ArrowRight />
        </Button>
      </div>
    </NewsCard>
  );
};
